import styled from 'styled-components';

import theme from '@theme/FolxTheme';

export type IGridColumn = [
	mobile: number,
	tablet: number,
	laptop: number,
	laptopL?: number | undefined,
	desktop?: number | undefined
];

interface IGridItemProps {
	columnStart: IGridColumn;
	columnEnd: IGridColumn;
}

const GridItem = styled.div<IGridItemProps>`
	grid-column-start: ${({ columnStart: [mobile] }) => mobile};
	grid-column-end: ${({ columnEnd: [mobile] }) => mobile};

	@media ${theme.responsive.breakpoints.tablet} {
		grid-column-start: ${({ columnStart: [_, tablet] }) => tablet};
		grid-column-end: ${({ columnEnd: [_, tablet] }) => tablet};
	}

	@media ${theme.responsive.breakpoints.laptop} {
		grid-column-start: ${({ columnStart: [_, __, laptop] }) => laptop};
		grid-column-end: ${({ columnEnd: [_, __, laptop] }) => laptop};
	}

	@media ${theme.responsive.breakpoints.laptopL} {
		grid-column-start: ${({ columnStart: [_, __, laptop, laptopL] }) => laptopL ?? laptop};
		grid-column-end: ${({ columnEnd: [_, __, laptop, laptopL] }) => laptopL ?? laptop};
	}

	@media ${theme.responsive.breakpoints.desktop} {
		grid-column-start: ${({ columnStart: [_, __, laptop, laptopL, desktop] }) =>
			desktop ?? laptopL ?? laptop};
		grid-column-end: ${({ columnEnd: [_, __, laptop, laptopL, desktop] }) =>
			desktop ?? laptopL ?? laptop};
	}
`;

export default GridItem;
